import React from "react";

import { SuccessIcon, InfoSmIcon } from "@packages/ds";
import { useIntl } from "react-intl";

import { ThirdParty } from "Constants/integrationThirdParties";
import Dialog from "ds/Dialog/Dialog";
import IntegrationIcon from "src/organization/pages/project/settings/integrations/components/IntegrationIcon";

import * as S from "./IntegrationItem.styles";

type IntegrationItemProps = {
  integration: ThirdParty;
  onSelect: (e?: React.MouseEvent) => void;
  isConnected?: boolean;
  allowEdit?: boolean;
};

const IntegrationItem = ({
  integration,
  onSelect,
  isConnected,
  allowEdit
}: IntegrationItemProps) => {
  const intl = useIntl();

  const { type, description } = integration;
  const name = intl.formatMessage({ id: `integration.type.${type}` });
  return (
    <S.Wrapper disabled={!allowEdit}>
      <S.Header>
        <IntegrationIcon type={type} />
        <S.Name weight="bold" size="medium">
          {name}
        </S.Name>
      </S.Header>
      <S.Description>
        {intl.formatMessage({ id: description }, { name })}
      </S.Description>
      <S.Footer>
        {integration.actionLinks?.length ? (
          <S.IntegrationActionLinkWrapper>
            {integration.actionLinks?.map(link => {
              return (
                <S.ActionBtn
                  analyticId="integration.setup.add"
                  variant="link"
                  key={intl.formatMessage({ id: link.title })}
                  href={intl.formatMessage({
                    id: link.href
                  })}
                >
                  {intl.formatMessage({ id: link.title })}
                </S.ActionBtn>
              );
            })}
          </S.IntegrationActionLinkWrapper>
        ) : isConnected ? (
          <S.Connected>
            <SuccessIcon />
            {intl.formatMessage({ id: "integration.setup.connected" })}
          </S.Connected>
        ) : (
          <S.ActionBtn
            analyticId="integration.setup.add"
            variant="link"
            disabled={!allowEdit}
            onClick={allowEdit ? onSelect : undefined}
          >
            {intl.formatMessage({ id: "integration.setup.add" })}
          </S.ActionBtn>
        )}
        {integration.info && (
          <Dialog
            title={intl.formatMessage({
              id: integration.info.title
            })}
            description={intl.formatMessage({
              id: integration.info.description
            })}
            analyticId={integration.info.description}
            trigger={
              <div role="button" tabIndex={0} aria-label="integration-info">
                <InfoSmIcon color="var(--icon-granite-fill,var(--granite))" />
              </div>
            }
            link={
              <S.IntegrationActionLinkWrapper>
                {integration.info.links?.map(l => {
                  return (
                    <S.ActionBtn
                      variant="link"
                      key={intl.formatMessage({ id: l.title })}
                      href={intl.formatMessage({
                        id: l.href
                      })}
                    >
                      {intl.formatMessage({ id: l.title })}
                    </S.ActionBtn>
                  );
                })}
              </S.IntegrationActionLinkWrapper>
            }
          />
        )}
      </S.Footer>
    </S.Wrapper>
  );
};

export default IntegrationItem;
